import { ApplicationRef, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { EColorEstado, ETipoAlerta, ETraduccionEstadoPerfil } from 'src/app/models/enums.enum';
import { IPeticionAdmin, IRespuestaBuscarEmpresa, IRespuestaListaUsuario } from 'src/app/models/interfaces-apis/administracion';
import { IDiccionarios, IItem } from 'src/app/models/interfaces-apis/diccionarios';
import { IFichaCliente, IRespuestaFichaCliente } from 'src/app/models/interfaces-apis/ficha_cliente';
import { AdminService } from 'src/app/servicios/admin.service';
import { FormularioUsuarioComponent } from '../../vista-ficha-usuario/formulario/formulario-usuario/formulario-usuario.component';
import { IExpresion } from 'src/app/models/General/expresion-regular';
import { AlertaService } from 'src/app/shared/alerta.service';
import { TranslateService } from '@ngx-translate/core';
import * as dayjs from 'dayjs';
import { Util } from 'src/app/shared/util';



@Component({
  selector: 'app-tabla-usuarios',
  templateUrl: './tabla-usuarios.component.html',
  styleUrls: ['./tabla-usuarios.component.scss']
})
export class TablaUsuariosComponent implements OnInit {

  @ViewChild('formulario', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  instanciaFormulario: any = null


  @Input() usuarios: IRespuestaListaUsuario[] = [];
  @Input() diccionarios: IDiccionarios[] = []
  @Input() empresa: IRespuestaBuscarEmpresa = null;

  @Input() colorEstado: any;
  @Input() estadosFiltrados: any[] = [];
  @Input() nombreEstado: any
  lectura: boolean = true
  mostrarPoliticasCondiciones: boolean = false
  mostrar: boolean = false

  @Input() listaPaises: IItem[] = [];
  @Input() expresionesRegulares: IExpresion;
  @Input() listaPrefijos: IItem[];
  @Input() listaComunidades: IItem[];

 
  

  peticion: IPeticionAdmin = {
    Cliente: null
  }


  @ViewChild('modal') private modal: SwalComponent;

  clienteFicha: IFichaCliente = Util.crearInstanciaFichaCliente();;


  constructor(private _adminService: AdminService,  private _alertaService: AlertaService, private _translate: TranslateService) { }

  ngOnInit() {
    
  }

  //Nos devuelve los estados del perfil del cliente
  infoEstado(id: number) {
    return ETraduccionEstadoPerfil[id];
  }

  //Carga de Cliente para poder ver la informacion dentro del modal
  cargaCliente(cliente: IRespuestaListaUsuario) {
    this.instanciaFormulario = null
    if (this.instanciaFormulario == null) {
      this._alertaService.alertaToasts(this._translate.instant('precliente.formulario.alerta-cargando-datos'), ETipoAlerta.Info)
      this.insertElement()
    }

    this.peticion.Cliente = cliente.Id
    this._adminService.datosCliente(this.peticion).subscribe({
      next: (data: IRespuestaFichaCliente) => {
        this.clienteFicha.Nombre = data.PreCliente.Nombre;
        this.clienteFicha.Apellidos = data.PreCliente.Apellidos;
        this.clienteFicha.Genero = data.PreCliente.Genero
        this.clienteFicha.FechaNacimiento = this.fechaFormat(data.PreCliente.FechaNacimiento);
        this.clienteFicha.PreFijo = data.PreCliente.PreFijo;
        this.clienteFicha.Telefono = data.PreCliente.Telefono;
        this.clienteFicha.Newsletter = data.PreCliente.Newsletter;
        this.clienteFicha.FechaAceptacionPoliticas = data.PreCliente.FechaAceptacionPoliticas
        this.clienteFicha.Poblacion = data.PreCliente.Poblacion;
        this.clienteFicha.CodigoPostal = data.PreCliente.CodigoPostal;  
        this.clienteFicha.Direccion = data.PreCliente.Direccion;
        this.clienteFicha.Provincia = data.PreCliente.Provincia;
        this.clienteFicha.Pais = data.PreCliente.Pais;
        this.clienteFicha.Correo = data.DatosCliente.Email;
        this.clienteFicha.Documentos = data.PreCliente.Documentos;
        this.clienteFicha.TarjetasFidelizacion = data.PreCliente.TarjetasFidelizacion;
        this.clienteFicha.Preferencias = data.PreCliente.Preferencias;
        this.instanciaFormulario.instance.clienteFicha = this.clienteFicha
        this.instanciaFormulario.instance.actualizar();
        this.instanciaFormulario.instance.clienteFicha = this.clienteFicha
        this.instanciaFormulario.instance.actualizar();
      }
    });
    
  }

  //El formato que vamos a establecer para mostrar la fecha
    fechaFormat(fecha: string) {
      return dayjs(fecha).format("YYYY-MM-DDTHH:mm:ss");
    };
  
  insertElement(): void {
    this.viewContainerRef.clear();
    this.instanciaFormulario = this.viewContainerRef.createComponent(FormularioUsuarioComponent)
    this.instanciaFormulario.instance.diccionarios = this.diccionarios
    this.instanciaFormulario.instance.lectura = this.lectura
    this.instanciaFormulario.instance.listaPaises = this.listaPaises
    this.instanciaFormulario.instance.expresionesRegulares = this.expresionesRegulares
    this.instanciaFormulario.instance.listaPrefijos = this.listaPrefijos
    this.instanciaFormulario.instance.listaComunidades = this.listaComunidades
    this.instanciaFormulario.instance.mostrarPoliticasCondiciones = this.mostrarPoliticasCondiciones
    this.instanciaFormulario.instance.mostrar = this.mostrar
  }

 
}
